import { render, staticRenderFns } from "./orderItemDetail.vue?vue&type=template&id=53179f22&scoped=true&"
import script from "./orderItemDetail.vue?vue&type=script&lang=js&"
export * from "./orderItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53179f22",
  null
  
)

export default component.exports